import React from 'react';
import PropTypes from 'prop-types';
import Input from 'components/ui/Input';
import Label from 'components/ui/Label';
import { FormattedMessage } from 'react-intl';
import { StyledField, ErrorMessage } from './Field.styles';

const Field = ({ hasError, errorMessage, label, name, type, onChange, value }) => (
  <StyledField>
    <Label htmlFor={name}>
      <FormattedMessage id={label} />
    </Label>
    <Input name={name} type={type} id={name} onChange={onChange} value={value} validationState={hasError && 'error'} />
    {hasError && (
      <ErrorMessage>
        <FormattedMessage id={errorMessage} />
      </ErrorMessage>
    )}
  </StyledField>
);

Field.propTypes = {
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

Field.defaultProps = {
  hasError: false,
  errorMessage: '',
  type: 'text'
};

export default Field;
